import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom'
import DashboardHeader from '../shared/components/DashboardHeader';
import SideMenu from '../shared/components/SideMenu';
import Footer from '../shared/components/Footer';
import HttpCall from '../api/Http';
import SerializeClass from '../shared/Utils/serialized';
import User from '../shared/Utils/User'
import axios from 'axios';
import Alert from '../shared/Utils/AlertBox';
import Loader from '../shared/components/Loader';
import Moment from 'react-moment';
import File from '../shared/Utils/Filename';
import { ExcelRenderer, OutTable } from 'react-excel-renderer';

export default function LeadList() {

    const [inputValue, setInputValue] = useState({ name: "", template: "" });
    const [file, setFile] = useState(null)
    const [laedList, setLaedList] = useState([]);
    const [leadID, setLeadID] = useState(0);
    const [loader, setLoader] = useState(false);
    const { name, template } = inputValue;
    const user = User.getUser()
    const [options, setOptions] = useState({ channel: -1, lead_name: -1, first_name: -1, last_name: -1, department: -1, title: -1, seniority: -1, linkedinUrl: -1, email: -1, company: -1, companyUrl: -1, phone_number: -1, work_phone: -1, created_by: user[0].Id })
    const [columnsData, setColumnsData] = useState([])
    const [validation, setValidation] = useState(false);
    const [isRun, setIsRun] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setInputValue((prev) => ({ ...prev, [name]: value, }));
    };

    const handleSelectChange = (e) => {
        const { name, value } = e.target;
        setOptions((prev) => ({ ...prev, [name]: value, }));
    };

    function onFileChange(event) {
        setFile(event.target.files[0]);
        let fileObj = event.target.files[0];
        //just pass the fileObj as parameter
        ExcelRenderer(fileObj, (err, resp) => {
            if (err) {
                console.log(err);
            }
            else {
                Alert.show("", 'Please select the relevant columns to the Fields', "info");
                setColumnsData(resp.rows[0])
            }
        });
    };

    useEffect(() => {
        validateMapping();
        console.log(validation)
        if (!isRun) {
            getLeadList();
        }
        setIsRun(true)
    }, [options, validation, name])

    function validateMapping() {
        var isValidated = false;
        Object.keys(options).forEach(function (key) {
            if (options[key] == "") {
                isValidated = true;
                setValidation(false)
            }
        });

        if (!isValidated && name.length > 1)
            setValidation(true);
    }

    const getLeadList = () => {
        let arr = [];
        arr.push({ P_user_id: user[0].Id });
        let p = SerializeClass.getSerializedData(arr);
        let header = {
            headers: { 'Authorization': `Token ${user[0].token}` }
        };
        let url = `https://api.getbound.ai/api/user/getLeadList?Params=${p}`;
        axios.get(url, header).then(response => {
            if (response.data.code == 200) {
                setLaedList(response.data.data);
            } else {
                Alert.show("Error!", response.data.msg, "error");
            }
        }).catch(err => {
            console.log(err);
        })
    }

    function addLeadList(e) {

        e.preventDefault();
        if (name.length < 2) {
            return Alert.show("Error!", 'Please enter the Lead name', "error");
        }
        if (!file) {
            return Alert.show("Error!", 'Please upload the file', "error");
        }

        let requestData = new FormData();
        let arr = [];
        if (leadID > 0) {
            arr.push({ P_id: leadID });
            arr.push({ P_updated_by: user[0].Id });
            requestData.append('files', file)
        } else {
            arr.push({ P_user_id: user[0].Id });
            arr.push({ P_created_by: user[0].Id });
            requestData.append('files', file)
        }
        arr.push({ P_file_path: "lead-list-file-path" });
        arr.push({ P_file_name: file ? file.name : null });
        arr.push({ P_lead_list_name: name });
        arr.push({ P_lead_list_template: template });
        arr.push({ P_toal_records: "lead-list-records" });
        let p = SerializeClass.getSerializedData(arr);
        requestData.append('Params', p);
        requestData.append('mappings', JSON.stringify(options));
        setLoader(true);
        let url = leadID ? '/api/user/updateLeadList' : `/api/user/addLeadList`;
        HttpCall.postRequest2(url, requestData).then(response => {
            if (response.data.code == 200) {
                Alert.show("Success!", leadID ? "Lead Updated Successfully." : "Lead Added Successfully.", "success");
                setLoader(false);
                getLeadList();
                setInputValue(() => ({ name: '', template: '' }))
                window.location.reload(false);
            } else {
                if (!response.data.msg.includes("Your Lead List records are exceeding the standard limit"))
                    Alert.showUpgrade("Plan expired", response.data.msg, "error");
                else
                    Alert.show("Error!", response.data.msg, "error");
                setLoader(false)
            }
        }).catch(err => {
            console.log(err);
        })
    }

    const editLeadList = (row) => {
        setLeadID(row.id);
        setInputValue(() => ({ name: row.lead_list_name, template: row.lead_list_template }))
    }

    return (
        <>
            <DashboardHeader />
            {loader && <Loader />}
            <div className="container-fluid page-body-wrapper">
                <SideMenu />
                <div className="main-panel">
                    <div className="content-wrapper">
                        <div className="row">
                            <div className="col-md-12 grid-margin stretch-card">
                                <div className="card">
                                    <div className="card-body">
                                        <h4 className="card-title">Lead List > Potential Customer or Accounts</h4>
                                        <p className="card-description">
                                            Note: Share the list of potential customer and accounts for the AI Engine
                                        </p>
                                        <form className="forms-sample">

                                            <div className="form-group">
                                                <label htmlFor="exampleInputEmail1">Lead Name</label>
                                                <input type="name" className="form-control form-control-lg"
                                                    placeholder="Enter the name of the list" name='name' value={name} onChange={handleChange} />
                                            </div>

                                            {/* <div className="form-group">
                                                <label htmlFor="exampleInputEmail1">Lead List</label>
                                                <textarea className="form-control form-control-lg customtextarea"
                                                    onChange={handleChange} value={template} name="template"
                                                    placeholder="Create your lead list here or paste any data that you may have"></textarea>
                                            </div> */}
                                            <div className="form-group">
                                                <label>Browse File (EXCEL)</label>
                                                {/* <input type="file" name="img[]" className="file-upload-default"/> */}
                                                <div className="input-group col-xs-12">
                                                    <input type="file" onChange={onFileChange} accept=".xlsx" className="form-control file-upload-info form-control-lg marginsmall customchoosefile" placeholder="Upload File (CSV/PDF/DOC)" />
                                                </div>
                                            </div>
                                            <div className="form-group">
                                                <a href='https://content.getbound.ai/template_files/Lead List - Template.xlsx' download>Lead List Template</a>
                                            </div>
                                            <div class="row">
                                                <div class="col-md-12 grid-margin stretch-card">
                                                    <div class="card">
                                                        <div class="card-body">
                                                            <div class="row">
                                                                <div class="col-md-9">
                                                                    <h4 class="card-title">Column Mapping</h4>
                                                                    <p class="card-description">
                                                                        Note: Map the CSV columns to relevant Getbound fields.
                                                                    </p>
                                                                </div>
                                                            </div>
                                                            <form className="forms-sample">
                                                                <div className='row'>
                                                                    <div className='col-md-3'>
                                                                        <h4 class="card-title">Getbound Field</h4>
                                                                        <div className="form-group customformheight">
                                                                            <label>Channel</label>
                                                                        </div>
                                                                        <div className="form-group customformheight">
                                                                            <label>Lead Name</label>
                                                                        </div>
                                                                        <div className="form-group customformheight">
                                                                            <label>First Name</label>
                                                                        </div>
                                                                        <div className="form-group customformheight">
                                                                            <label>Last Name</label>
                                                                        </div>
                                                                        <div className="form-group customformheight">
                                                                            <label>Department</label>
                                                                        </div>
                                                                        <div className="form-group customformheight">
                                                                            <label>Title</label>
                                                                        </div>
                                                                        <div className="form-group customformheight">
                                                                            <label>Seniority (dir/prt)</label>
                                                                        </div>
                                                                        <div className="form-group customformheight">
                                                                            <label>Linkedin</label>
                                                                        </div>
                                                                        <div className="form-group customformheight">
                                                                            <label>Email</label>
                                                                        </div>
                                                                        <div className="form-group customformheight">
                                                                            <label>Company Name</label>
                                                                        </div>
                                                                        <div className="form-group customformheight">
                                                                            <label>Company URL</label>
                                                                        </div>
                                                                        <div className="form-group customformheight">
                                                                            <label>Mobile Phone Number</label>
                                                                        </div>
                                                                        <div className="form-group customformheight">
                                                                            <label>Work Phone Number</label>
                                                                        </div>
                                                                    </div>
                                                                    <div className='col-md-4'>
                                                                        <h4 class="card-title">CSV Column Header</h4>
                                                                        <div className="form-group customformheight">

                                                                            <select className="js-example-basic-single w-100 customselect form-control form-control-lg"
                                                                                onChange={handleSelectChange}
                                                                                name="channel"
                                                                                value={options.channel}>
                                                                                <option key="-1" value="-1">
                                                                                    Not Available
                                                                                </option>
                                                                                {columnsData.map((data, index) => (
                                                                                    <option key={index} value={index}>
                                                                                        {data}
                                                                                    </option>
                                                                                ))}
                                                                            </select>
                                                                        </div>
                                                                        <div className="form-group customformheight">
                                                                            <select className="js-example-basic-single w-100 customselect form-control form-control-lg"
                                                                                onChange={handleSelectChange}
                                                                                name="lead_name"
                                                                                value={options.lead_name}>
                                                                                <option key="-1" value="-1">
                                                                                    Not Available
                                                                                </option>
                                                                                {columnsData.map((data, index) => (
                                                                                    <option key={index} value={index}>
                                                                                        {data}
                                                                                    </option>
                                                                                ))}
                                                                            </select>
                                                                        </div>
                                                                        <div className="form-group customformheight">
                                                                            <select className="js-example-basic-single w-100 customselect form-control form-control-lg"
                                                                                onChange={handleSelectChange}
                                                                                name="first_name"
                                                                                value={options.first_name}>
                                                                                <option key="-1" value="-1">
                                                                                    Not Available
                                                                                </option>
                                                                                {columnsData.map((data, index) => (
                                                                                    <option key={index} value={index}>
                                                                                        {data}
                                                                                    </option>
                                                                                ))}
                                                                            </select>
                                                                        </div>
                                                                        <div className="form-group customformheight">
                                                                            <select className="js-example-basic-single w-100 customselect form-control form-control-lg"
                                                                                onChange={handleSelectChange}
                                                                                name="last_name"
                                                                                value={options.last_name}>
                                                                                <option key="-1" value="-1">
                                                                                    Not Available
                                                                                </option>
                                                                                {columnsData.map((data, index) => (
                                                                                    <option key={index} value={index}>
                                                                                        {data}
                                                                                    </option>
                                                                                ))}
                                                                            </select>
                                                                        </div>
                                                                        <div className="form-group customformheight">
                                                                            <select className="js-example-basic-single w-100 customselect form-control form-control-lg"
                                                                                onChange={handleSelectChange}
                                                                                name="department"
                                                                                value={options.department}>
                                                                                <option key="-1" value="-1">
                                                                                    Not Available
                                                                                </option>
                                                                                {columnsData.map((data, index) => (
                                                                                    <option key={index} value={index}>
                                                                                        {data}
                                                                                    </option>
                                                                                ))}
                                                                            </select>
                                                                        </div>
                                                                        <div className="form-group customformheight">
                                                                            <select className="js-example-basic-single w-100 customselect form-control form-control-lg"
                                                                                onChange={handleSelectChange}
                                                                                name="title"
                                                                                value={options.title}>
                                                                                <option key="-1" value="-1">
                                                                                    Not Available
                                                                                </option>
                                                                                {columnsData.map((data, index) => (
                                                                                    <option key={index} value={index}>
                                                                                        {data}
                                                                                    </option>
                                                                                ))}
                                                                            </select>
                                                                        </div>
                                                                        <div className="form-group customformheight">
                                                                            <select className="js-example-basic-single w-100 customselect form-control form-control-lg"
                                                                                onChange={handleSelectChange}
                                                                                name="seniority"
                                                                                value={options.seniority}>
                                                                                <option key="-1" value="-1">
                                                                                    Not Available
                                                                                </option>
                                                                                {columnsData.map((data, index) => (
                                                                                    <option key={index} value={index}>
                                                                                        {data}
                                                                                    </option>
                                                                                ))}
                                                                            </select>
                                                                        </div>
                                                                        <div className="form-group customformheight">
                                                                            <select className="js-example-basic-single w-100 customselect form-control form-control-lg"
                                                                                onChange={handleSelectChange}
                                                                                name="linkedinUrl"
                                                                                value={options.linkedinUrl}>
                                                                                <option key="-1" value="-1">
                                                                                    Not Available
                                                                                </option>
                                                                                {columnsData.map((data, index) => (
                                                                                    <option key={index} value={index}>
                                                                                        {data}
                                                                                    </option>
                                                                                ))}
                                                                            </select>
                                                                        </div>
                                                                        <div className="form-group customformheight">
                                                                            <select className="js-example-basic-single w-100 customselect form-control form-control-lg"
                                                                                onChange={handleSelectChange}
                                                                                name="email"
                                                                                value={options.email}>
                                                                                <option key="-1" value="-1">
                                                                                    Not Available
                                                                                </option>
                                                                                {columnsData.map((data, index) => (
                                                                                    <option key={index} value={index}>
                                                                                        {data}
                                                                                    </option>
                                                                                ))}
                                                                            </select>
                                                                        </div>
                                                                        <div className="form-group customformheight">
                                                                            <select className="js-example-basic-single w-100 customselect form-control form-control-lg"
                                                                                onChange={handleSelectChange}
                                                                                name="company"
                                                                                value={options.company}>
                                                                                <option key="-1" value="-1">
                                                                                    Not Available
                                                                                </option>
                                                                                {columnsData.map((data, index) => (
                                                                                    <option key={index} value={index}>
                                                                                        {data}
                                                                                    </option>
                                                                                ))}
                                                                            </select>
                                                                        </div>
                                                                        <div className="form-group customformheight">
                                                                            <select className="js-example-basic-single w-100 customselect form-control form-control-lg"
                                                                                onChange={handleSelectChange}
                                                                                name="companyUrl"
                                                                                value={options.companyUrl}>
                                                                                <option key="-1" value="-1">
                                                                                    Not Available
                                                                                </option>
                                                                                {columnsData.map((data, index) => (
                                                                                    <option key={index} value={index}>
                                                                                        {data}
                                                                                    </option>
                                                                                ))}
                                                                            </select>
                                                                        </div>
                                                                        <div className="form-group customformheight">
                                                                            <select className="js-example-basic-single w-100 customselect form-control form-control-lg"
                                                                                onChange={handleSelectChange}
                                                                                name="phone_number"
                                                                                value={options.phone_number}>
                                                                                <option key="-1" value="-1">
                                                                                    Not Available
                                                                                </option>
                                                                                {columnsData.map((data, index) => (
                                                                                    <option key={index} value={index}>
                                                                                        {data}
                                                                                    </option>
                                                                                ))}
                                                                            </select>
                                                                        </div>
                                                                        <div className="form-group customformheight">
                                                                            <select className="js-example-basic-single w-100 customselect form-control form-control-lg"
                                                                                onChange={handleSelectChange}
                                                                                name="work_phone"
                                                                                value={options.work_phone}>
                                                                                <option key="-1" value="-1">
                                                                                    Not Available
                                                                                </option>
                                                                                {columnsData.map((data, index) => (
                                                                                    <option key={index} value={index}>
                                                                                        {data}
                                                                                    </option>
                                                                                ))}
                                                                            </select>
                                                                        </div>
                                                                    </div>
                                                                    <div className='col-md-5'>
                                                                        <h4 class="card-title">Example Data</h4>
                                                                        <div className="form-group customformheight">
                                                                            <label>Linkedin, Facebook, Twitter</label>
                                                                        </div>
                                                                        <div className="form-group customformheight">
                                                                            <label>Warren Thornton, Zelene Goodwin, Lance Cross</label>
                                                                        </div>
                                                                        <div className="form-group customformheight">
                                                                            <label>Winston Nguyen, Avery Snyder</label>
                                                                        </div>
                                                                        <div className="form-group customformheight">
                                                                            <label>Eddie Hanson, Gerald Adams</label>
                                                                        </div>
                                                                        <div className="form-group customformheight">
                                                                            <label>Accountant, Marketing, Sales Management</label>
                                                                        </div>
                                                                        <div className="form-group customformheight">
                                                                            <label>Partner at PwC, Partner, Partner, Business Transformation</label>
                                                                        </div>
                                                                        <div className="form-group customformheight">
                                                                            <label>Director / Partner</label>
                                                                        </div>
                                                                        <div className="form-group customformheight">
                                                                            <label>https://www.linkedin.com/example66</label>
                                                                        </div>
                                                                        <div className="form-group customformheight">
                                                                            <label>example@gmail.com</label>
                                                                        </div>
                                                                        <div className="form-group customformheight">
                                                                            <label>Google, Microsoft</label>
                                                                        </div>
                                                                        <div className="form-group customformheight">
                                                                            <label>www.example.com</label>
                                                                        </div>
                                                                        <div className="form-group customformheight">
                                                                            <label>(555) 555-1234</label>
                                                                        </div>
                                                                        <div className="form-group customformheight">
                                                                            <label>(555) 453-5334</label>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </form>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-12">
                                                    <button type="submit" className="btn btn-primary me-2 savebtn"
                                                        disabled={!validation} onClick={addLeadList}>Save</button>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-12 grid-margin stretch-card">
                                <div className="card">
                                    <div className="card-body">
                                        <h4 className="card-title"></h4>

                                        <div className="table-responsive">
                                            <table className="table">
                                                <thead>
                                                    <tr>
                                                        <th>#</th>
                                                        <th>Lead Name</th>
                                                        <th>File Name</th>
                                                        <th>Created</th>
                                                        {/* <th>Status</th> */}
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {laedList.length > 0 && laedList.map((data, index) => (<tr key={index}>
                                                        <td>{index + 1}</td>
                                                        <td>{data.lead_list_name}</td>
                                                        <td>{data._file_name}</td>
                                                        <td><Moment format="DD-MM-YYYY">{data.created_on}</Moment></td>
                                                        {/* <td><label className="badge badge-danger">{data.status_id}</label></td> */}
                                                        <td>
                                                            <button type="submit" className="btn btn-primary me-2 savebtn" onClick={() => { editLeadList(data) }}>Edit</button>
                                                        </td>
                                                    </tr>))}

                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Footer />
                </div>
            </div>
        </>

    )
}